import { Outlet } from '@tanstack/react-router';
import React, { ReactElement } from 'react';

function SourcesContainer(): ReactElement {
  return <Outlet />;
}

export default SourcesContainer;
